import TypeTable from "./view/TypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LeasedEquipmentType = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_leasedequipment_type_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewPermission) ? <TypeTable /> : ""}</>;
};

export default LeasedEquipmentType;
